import { theme } from '@frontend/theme';
import { Text, TextProps } from '@frontend/design-system';
import { StringMatch } from './utils/convert-string-to-matched-words';

type TextWithMatchesProps = {
  text: StringMatch[];
} & Omit<TextProps, 'children'>;

export const TextWithMatches = ({ text, ...rest }: TextWithMatchesProps) => {
  return (
    <Text {...rest} textAlign='left'>
      {text.map(({ str, isMatch }, index) =>
        isMatch ? (
          <span key={str + '-' + index} css={{ fontWeight: theme.font.weight.bold }}>
            {str}
          </span>
        ) : (
          str
        )
      )}
    </Text>
  );
};
